import { render, staticRenderFns } from "./IncDocSFTP.vue?vue&type=template&id=4c547df9&"
import script from "./IncDocSFTP.vue?vue&type=script&lang=js&"
export * from "./IncDocSFTP.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports